import React from 'react';
import logoSrc from '../assets/saitour-logo.png';

const Logo = ({ className = '', height = 44 }) => (
  <img
    src={logoSrc}
    alt="SaiTour logo"
    className={`logo-image ${className}`.trim()}
    style={{ height, width: 'auto' }}
  />
);

export default Logo;
